import React, { useMemo, useState } from 'react';

import css from './Query.less';
import Tags from 'src/components/Tags/Tags';
import Sort from './Sort';
import Filter from 'src/components/FilterGroup/Filter';
import { FilterType } from '../../components/FilterGroup/types';
export { FilterType };

interface IProps {
  filterList?; //filter数据，不传不展示filter
  state?;
  sortList?; //sort数据，数组形式，不传不展示sort
  searchList; //search数据，数组形式，不传不展示searchTags
  sortBy?;
  deleteSearch?;
  activeChange?;
  onSearch?: (value) => void;
  onPress;
  overlayOnClick?;
  eachOnFilterClick?;
  onSortClick?;
  onTagClose?: (index) => void;
  filter?;
  placeholder?: string;
  filterCloseClick?;
  className?: string;
  filterClassName?: string;
}

const Query = (props: IProps) => {
  const {
    filterList,
    state,
    sortList = [],
    onSearch: searchFun,
    onPress,
    filter,
    searchList,
    eachOnFilterClick,
    onSortClick,
    onTagClose,
    placeholder,
    filterClassName,
    filterCloseClick,
    className,
  } = props;
  const [searchValue, setSearchValue] = useState('');
  //点击Search按钮
  const onSearch = (value) => {
    setSearchValue('');
    if (value && searchFun) searchFun(value);
  };
  const pressEnter = (e) => {
    //用户点击回车事件
    const { value } = e.target;
    setSearchValue('');
    if (value && onPress) onPress(value);
  };

  // search输入
  const searchOnchange = (value) => {
    // let valueFormat = value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g, '');
    setSearchValue(value || '');
  };
  const overlayClick = (checkedAll, list) => {
    console.log(checkedAll, list);
    const payload = { key: checkedAll.dataKey, data: list };
    if (eachOnFilterClick) eachOnFilterClick(payload);
  };
  const sortClick = (list) => {
    if (onSortClick) onSortClick(list);
  };

  const tagClose = (e, index) => {
    if (onTagClose) onTagClose(index);
  };
  const clearProductType = (key, index) => {
    // 关闭tags
    const payload = { key, index };
    if (filterCloseClick) filterCloseClick(payload);
  };
  const tagText = useMemo(() => {
    return (
      filter &&
      Object.keys(filter).map((key) => {
        const name = filter[key].map((value) => value.name);
        return (
          <Tags
            key={key}
            onClose={(e, index) => clearProductType(key, index)}
            data={name}
          />
        );
      })
    );
  }, [filter]);
  return (
    <div className={`${css.query} ${className}`}>
      <div className={css.queryAll}>
        <Filter
          overlayClick={overlayClick}
          filterList={filterList}
          filterData={filter}
          searchValue={searchValue}
          onSearch={onSearch}
          placeholder={placeholder}
          pressEnter={pressEnter}
          className={filterClassName}
          searchOnchange={searchOnchange}
        />

        {sortList && sortList.length ? (
          <div className={css.sortBy}>
            <Sort
              sortList={sortList}
              name={state.sort.name}
              sortClick={sortClick}
              sortKey={state.sort.key}
            />
          </div>
        ) : (
          ''
        )}
      </div>
      <div className={css.searchContain}>
        <Tags onClose={tagClose} data={searchList} />
        {tagText}
      </div>
    </div>
  );
};
export default Query;
